import Typography from 'APP/Converse/Typography'
import { useFilePreview } from './provider'
import { convertFileSize } from 'APP/Lib/ImagePickerHelpers'
import { TextContainer } from './styles'
import React from 'react'

/* FileMetadata component displays the name and size of the file being previewed.
 * @returns {JSX.Element|null} The rendered file metadata or null if no file is available.
 */
function FileMetadata() {
  const { file } = useFilePreview()

  if (!file) return null

  const fileSize = convertFileSize(file.size)
  return (
    <TextContainer testID="FILE_METADATA_CONTAINER">
      <Typography
        variant="bodySmallBold"
        color="text"
        numberOfLines={1}
        accessibilityRole="text"
        testID="FILE_NAME"
      >
        {file?.name}
      </Typography>
      <Typography variant="bodySmall" color="dim" accessibilityRole="text" testID="FILE_SIZE">
        {fileSize}
      </Typography>
    </TextContainer>
  )
}

export default FileMetadata
